/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.filter-group__body .collection-nav label span').forEach(function(span) {
      span.textContent = span.textContent.replace(/[\s\u00A0]+/g, '');
 
    });
  });
document.addEventListener("DOMContentLoaded", function() {
  // Get all hidden radio fieldsets
  const hiddenFieldsets = document.querySelectorAll('.radio__fieldset.hidden');
  
  hiddenFieldsets.forEach(fieldset => {
    // Find the closest parent product__block
    const productBlock = fieldset.closest('.product__block.product__block--lines.product__form__holder.block-padding');
    
    if (productBlock) {
      productBlock.style.display = 'none';  // Hide it
    }
  });
});